import { useEffect, useState } from "react";
import ApplicationTypeComponent from "../../../components/applicationComponents/applicationType/ApplicationTypeComponent";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import SupportRequestedComponent from "../../../components/applicationComponents/supportRequested/SupportRequestedComponent";
import KindergartenComponent from "../../../components/applicationComponents/kindergartenComponent/KindergartenComponent";
import GroupInformationComponent from "../../../components/applicationComponents/groupInformation/groupInformationComponent";
import ProvidingInclusiveKindergartenEnvironmentComponent from "../../../components/applicationComponents/providingInclusiveKindergartenEnvironment/ProvidingInclusiveKindergartenEnvironmentComponent";
import ChildComponent from "../../../components/applicationComponents/child/ChildComponent";
import ChildAttendanceComponent from "../../../components/applicationComponents/childAttendance/ChildAttendanceComponent";
import ContextOfChildComponent from "../../../components/applicationComponents/contextOfChild/ContextOfChildComponent";
import ApplicationCreationComponent from "../../../components/applicationComponents/applicationCreation/ApplicationCreationComponent";
import ScreeningQuestionsComponent from "../../../components/applicationComponents/screeningQuestions/ScreeningQuestionsComponent";
import SupportingDocumentsComponent from "../../../components/applicationComponents/supportingDocuments/SupportingDocumentsComponent";

export default function ApplicationProviderView() {
  const [loaded, setLoaded] = useState(false);

  const { setHeaderText, applicationBase, rehydrate } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "View Application",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
    rehydrate().then(() => {
      setLoaded(true);
    });
  }, []);

  return (
    <div className="w-full">
      {loaded && (
        <div className="flex flex-col align-items-start w-full height-calc">
          <ScreeningQuestionsComponent disabled={true} data={applicationBase.screeningQuestions}></ScreeningQuestionsComponent>
          <ApplicationCreationComponent disabled={true}></ApplicationCreationComponent>
          <SupportRequestedComponent disabled={true} data={applicationBase.supportRequested}></SupportRequestedComponent>
          <KindergartenComponent disabled={true} data={applicationBase.kindergarten}></KindergartenComponent>
          <GroupInformationComponent disabled={true} data={applicationBase.groupInformation}></GroupInformationComponent>
          <ProvidingInclusiveKindergartenEnvironmentComponent
            disabled={true}
            data={applicationBase.providingInclusiveKindergartenEnvironment}></ProvidingInclusiveKindergartenEnvironmentComponent>
          <ChildComponent disabled={true} data={applicationBase.child}></ChildComponent>
          <ChildAttendanceComponent disabled={true} data={applicationBase.childAttendance}></ChildAttendanceComponent>
          <ContextOfChildComponent disabled={true} data={applicationBase.contextOfChild}></ContextOfChildComponent>
          <SupportingDocumentsComponent disabled={true} data={applicationBase.supportingDocuments}></SupportingDocumentsComponent>
          <ApplicationTypeComponent disabled={true} data={applicationBase.applicationType}></ApplicationTypeComponent>
        </div>
      )}
    </div>
  );
}
